export default __webpack_public_path__ + "static/media/more-horizontal.a8c4c007.svg";